import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "counter"];
  static values = {
    maxLength: { type: Number, default: 10 },
  };

  connect() {
    this.updateCounter();
  }

  updateCounter() {
    const count = this.inputTarget.value.length;
    this.counterTarget.textContent = count;

    if (count > this.maxLengthValue) {
      this.counterTarget.classList.add("text-red-500");
    } else {
      this.counterTarget.classList.remove("text-red-500");
    }
  }
}
